import { InAppBrowser } from '@/src/common/components/InAppBrowser'
import { isProduction } from '@/src/common/environment'
import { routerBack } from '@/src/common/utils/routerBack'
import { useFeatureGate } from '@/src/services/Statsig/useFeatureGate'
import { Platform, View } from 'react-native'
import { Statsig } from '..'
import { openInAppBrowser } from '@/src/common/utils/openInAppBrowser'

const javascript = `
  (function() {
     // Find and remove the meta tag responsible for the Smart App Banner
    var appleMetaTag = document.querySelector('meta[name="apple-itunes-app"]');
    if (appleMetaTag) {
      appleMetaTag.remove();
    }
    
    // Breaks any script they may add later to add meta tag
    var brokenAppleMetaTag = document.createElement('meta');
    brokenAppleMetaTag.name = 'apple-itunes-app';
    brokenAppleMetaTag.content = 'app-id='; // Empty or invalid content to disable
    document.head.appendChild(brokenAppleMetaTag);

    var elements = document.getElementsByClassName('sc-jnOGJG kkYVNS');
    for (var i = 0; i < elements.length; i++) {
      elements[i].parentNode.removeChild(elements[i]);
    }
  })();
  true; // Required to signal completion to WebView
`

export const myLowesRegistration = isProduction
  ? 'https://www.lowes.com/u/register/personal?appName=mesa&persona=diy'
  : 'https://lwscomsit4.lowes.com/u/register/personal?appName=mesa&persona=diy'

export function MyLowesRewardWebview() {
  const isMyLowesRewardJSInjectionActive = useFeatureGate(
    Statsig.FeatureGate.MyLowesRewardsJSInjection,
  ).featureGate?.value

  if (Platform.OS === 'web') {
    void openInAppBrowser(myLowesRegistration, "My Lowe's Rewards", 'tab')
    void routerBack()
    return null
  }

  return (
    <View style={{ flex: 1 }}>
      <View style={{ marginBottom: 12 }} />
      <InAppBrowser
        title={`My Lowe's Rewards`}
        uri={myLowesRegistration}
        injectJavaScript={isMyLowesRewardJSInjectionActive ? javascript : ''}
        onBackPress={() => void routerBack()}
        safeAreaEdges={['left', 'right']}
      />
    </View>
  )
}
